import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // 1. Reset standard window scroll
    window.scrollTo(0, 0);
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;

    // 2. Reset any potential custom scroll containers on your pages
    const scrollableElements = document.querySelectorAll(
      ".home-page, .builder-layout, .canvas-area, main",
    );
    scrollableElements.forEach((el) => {
      if (el) el.scrollTop = 0;
    });
  }, [pathname]);

  return null;
}
